import React from "react";
import {
  FilterableCounts,
  FilterQuery,
  ParameterFilterOption,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { useToggleParameterFilter } from "../../helpers/use_toggle_parameter_filter";
import { ParameterTitleButton } from "./parameter_title_button";
import { ParameterFilterRemoveHandler } from "../types";
import styles from "./boolean_parameter_filter_controls.module.sass";

type BooleanParameterFilterItemProps = {
  parameterId: number;
  value: string;
  count: number;
  selected: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const BooleanParameterFilterControlsItem = ({
  parameterId,
  value,
  count,
  selected,
  onChange,
}: BooleanParameterFilterItemProps) => (
  <li>
    <label>
      <input
        type="radio"
        name={`booleanParameter_${parameterId}`}
        checked={selected}
        onChange={onChange}
        disabled={count === 0}
      />
      <span>
        {value} <b>({count})</b>
      </span>
    </label>
  </li>
);

type BooleanParameterFilterControlsProps = {
  parameter: ParameterFilterOption;
  filterableCounts: FilterableCounts["booleanParameters"];
  filteredParameters: FilterQuery["booleanParameters"];
  onChange: (parameterId: number, newFilterValue: boolean) => void;
  onRemove: ParameterFilterRemoveHandler;
  onShowHint: (description: string) => void;
};

export const BooleanParameterFilterControls = ({
  parameter,
  filterableCounts,
  filteredParameters,
  onChange,
  onRemove,
  onShowHint,
}: BooleanParameterFilterControlsProps): JSX.Element | null => {
  const countsByValueId: Record<number, number> =
    filterableCounts[parameter.id];

  const [isExpanded, toggleIsExpanded] = useToggleParameterFilter(
    parameter,
    filteredParameters?.[parameter.id]
  );

  if (!countsByValueId) {
    return null;
  }

  return (
    <fieldset>
      <ParameterTitleButton
        parameter={parameter}
        isExpanded={isExpanded}
        toggleIsExpanded={toggleIsExpanded}
        onShowHint={onShowHint}
      />
      {isExpanded && (
        <>
          <ul>
            <BooleanParameterFilterControlsItem
              parameterId={parameter.id}
              value="Ano"
              count={countsByValueId[0]}
              onChange={() => onChange(parameter.id, true)}
              selected={filteredParameters?.[parameter.id] === true}
            />
            <BooleanParameterFilterControlsItem
              parameterId={parameter.id}
              value="Ne"
              count={countsByValueId[1]}
              onChange={() => onChange(parameter.id, false)}
              selected={filteredParameters?.[parameter.id] === false}
            />
          </ul>

          {filteredParameters?.[parameter.id] !== undefined && (
            <RemoveFilterButton
              onRemove={() => onRemove("booleanParameters", parameter.id)}
            />
          )}
        </>
      )}
    </fieldset>
  );
};

type RemoveFilterButtonProps = {
  onRemove: () => void;
};

const RemoveFilterButton = ({
  onRemove,
}: RemoveFilterButtonProps): JSX.Element => (
  <button className={styles.resetButton} type="button" onClick={onRemove}>
    vymazat filtr
  </button>
);
